//
//
//
//
//
//
//
//
//
//
const SquareImage = () => import('~/components/atoms/Product/SquareImage.vue');

export default {
  name: 'ZoomableImage',
  components: {
    SquareImage
  },
  props: {
    alt: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      delayClick: 400,
      tapFirst: false
    };
  },

  mounted() {
    this.initPanzoom();
  },

  methods: {
    initPanzoom() {
      if (process.client) {
        /* eslint-disable global-require */
        const Panzoom = require('@panzoom/panzoom');
        /* eslint-enable global-require */


        const panzoomElement = Panzoom(this.$refs.pinchReference, {
          minScale: 1,
          maxScale: 3,
          contain: 'outside',
          startScale: 1,
          zoom: 3,
          step: 1
        });
        panzoomElement.setStyle('touchAction', 'pan-y');
        this.$refs.pinchReference.addEventListener('touchstart', event => {
          if (!this.tapFirst) {
            this.tapFirst = true;
            this.tapTimeout = setTimeout(() => {
              this.tapFirst = false;
            }, this.delayClick);
          } else {
            if (this.getScale() >= 3) {
              panzoomElement.reset();
              panzoomElement.setStyle('touchAction', 'pan-y');
            } else if (this.getScale() >= 2) {
              panzoomElement.zoom(3, {
                animate: true
              });
            } else {
              panzoomElement.zoom(2, {
                animate: true
              });
              panzoomElement.setStyle('touchAction', '');
            }

            this.tapFirst = false;
            this.tapTimeout = clearTimeout(this.tapTimeout);
            event.preventDefault();
            event.stopPropagation();
          }

          if (this.isZoomed() || this.isPinched(event)) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
        this.$refs.pinchReference.addEventListener('touchmove', event => {
          if (this.isZoomed() || this.isPinched(event)) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
        this.$refs.pinchReference.addEventListener('touchend', event => {
          if (this.isZoomed()) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
        this.$refs.pinchReference.addEventListener('touchleave', event => {
          if (this.isZoomed() || this.isPinched(event)) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
        this.$refs.pinchReference.addEventListener('touchcancel', event => {
          if (this.isZoomed() || this.isPinched(event)) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
      }
    },

    isZoomed() {
      return this.getScale() > 1;
    },

    isPinched(eventScope) {
      return eventScope.targetTouches.length === 2;
    },

    isTouched(eventScope) {
      return eventScope.targetTouches.length === 1;
    },

    regexScale(scale) {
      const regex = /(\w+)\(([^)]*)\)/g;
      return regex.exec(scale);
    },

    getScale() {
      const {
        style
      } = this.$refs.pinchReference;
      const [,, scaleValue] = this.regexScale(style.transform);
      return parseFloat(scaleValue, 10);
    }

  }
};